import callAPI from "config/callAPI";

import React from "react";

const ENDPOINT = process.env.REACT_APP_BACKEND_URL + '/portal_utilities';

class PortalTopMenu extends React.Component {

    constructor(props){
        super(); 
        this.state = {
            page_name: props.page_name,
            rstatus: '',
            rmessage: '',
            userdata: []
        }

        this.getUserData();
    }

    async getUserData(){
        var data = {action: 'get_userdata'};

        const {rstatus, rmessage, rdata } = await callAPI(ENDPOINT, data); 
        this.setState({
            rstatus: rstatus,
            rmessage: rmessage,
            userdata: rdata.userdata
        });
    }

    render() {
        return (
            <>
                <div className="top-bar">
                    <div className="-intro-x breadcrumb mr-auto hidden sm:flex"> <a href="/portal/home" className="">UShort</a> <i data-feather="chevron-right" className="breadcrumb__icon"></i> <a href="#/" className="breadcrumb--active">{this.state.page_name}</a> </div>
                    <div className="intro-x relative mr-3 sm:mr-6"></div>
                    <div className="intro-x dropdown mr-auto sm:mr-6"></div>
                    <div className="intro-x dropdown w-8 h-8">
                        <div className="dropdown-toggle w-8 h-8 rounded-full overflow-hidden shadow-lg image-fit zoom-in">
                            <img alt={this.state.userdata.fname + ' ' + this.state.userdata.lname} src="/assets/midone/images/user.jpg" />
                        </div>
                        <div className="dropdown-box w-56">
                            <div className="dropdown-box__content box bg-theme-38 dark:bg-dark-6 text-white">
                                <div className="p-4 border-b border-theme-40 dark:border-dark-3">
                                    <div className="font-medium">{this.state.userdata.fname + this.state.userdata.lname !== '' ? this.state.userdata.fname  + ' ' + this.state.userdata.lname : '--'}</div>
                                </div>
                                <div className="p-2">
                                    <a href="/portal/account/settings" className="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3 rounded-md"> <i data-feather="edit" className="w-4 h-4 mr-2"></i> Account Settings </a>
                                    <a href="/portal/signout" className="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3 rounded-md"> <i data-feather="toggle-right" className="w-4 h-4 mr-2"></i> Signout </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default PortalTopMenu;